import Request from './Request';
import Response from './Response';

export default abstract class AbstractApi {
  public abstract call(request: Request, channel?: string): Promise<Response>;
  public abstract send(request: Request, channel?: string): void;
}
